import { SHOW_ACCESS_DENIED, CLEAR_ACCESS_DENIED, SHOW_NO_PERMISSION, CLEAR_NO_PERMISSION } from "../actions/accessActions";

const initialState = {
	showAccessDeniedModal: false,
    showNoPermissionModal: false,
};

export default function accessReducer(state = initialState, action: any) {
	switch (action.type) {
		case SHOW_ACCESS_DENIED:
			return { ...state, showAccessDeniedModal: true };
		case CLEAR_ACCESS_DENIED:
			return { ...state, showAccessDeniedModal: false };
        case SHOW_NO_PERMISSION:
            return { ...state, showNoPermissionModal: true };
        case CLEAR_NO_PERMISSION:
            return { ...state, showNoPermissionModal: false };
        default:
            return state;
	}
}
